import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class LookupService {
  private apiURL: string = '';

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
  }

  getGearTypes() {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + '/api/Lookup/lstGearType', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getManufacturerLookup(manufacturer: string) {
    let data = { Manufacturer: manufacturer };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/lstManufacturerAutocompleteLookup',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getModelLookup(manufacturer: string, model: string) {
    let data = { Manufacturer: manufacturer, Model: model };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/lstModelAutocompleteLookup',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getYearLookup(manufacturer: string, model: string, year: string) {
    let data = { Manufacturer: manufacturer, Model: model, ModelYear: year };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/lstModelYearAutocompleteLookup',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
